import { type User } from '@common/clients/api';
import { UserService } from '@common/clients/api/generated/sdk.gen';
import { createApiClient } from '@common/clients/request/api-client';
import { type ContextData } from '@common/defaults/ContextData';
import { type UserContext } from '@common/defaults/UserContext';

export const fetchCurrentUserProfile = async (
    contextData: ContextData,
    userContext: UserContext | undefined,
    editionID?: number,
): Promise<User | undefined> => {
    const client = createApiClient({ contextData, userContext });

    const { data } = await UserService.getProfileByIdUser({
        client,
        query: {
            editionID,
        },
    });

    return data;
};
